import { render } from "./DashboardHelpSection.vue?vue&type=template&id=7201b14f"
import script from "./DashboardHelpSection.vue?vue&type=script&lang=js"
export * from "./DashboardHelpSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__